import { Switch } from 'antd';
import styled from 'styled-components';

export const LggToggleSwitch = styled(Switch)`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.casper};
  height: 20px;
  min-width: unset;
  width: 38px;

  .ant-switch-handle {
    height: 16px;
    top: 1px;
    width: 16px;

    ::before {
      background: ${({ theme }) => theme.colors.flint};
    }
  }

  &.ant-switch-checked {
    background: ${({ theme }) => theme.colors.cosmo};
    border-color: ${({ theme }) => theme.colors.cosmo};

    .ant-switch-handle {
      left: calc(100% - 17px) !important;

      ::before {
        background: ${({ theme }) => theme.colors.white};
      }
    }
  }
` as typeof Switch;
